const REFERRAL_STORAGE_KEY = "mockee_referral_id";

export const parseReferralId = (value) => {
  const id = Number(value);
  return Number.isInteger(id) && id > 0 ? id : null;
};

export const getStoredReferralId = () => {
  try {
    return parseReferralId(sessionStorage.getItem(REFERRAL_STORAGE_KEY));
  } catch {
    return null;
  }
};

export const storeReferralId = (value) => {
  const id = parseReferralId(value);
  if (!id) return null;
  try {
    sessionStorage.setItem(REFERRAL_STORAGE_KEY, String(id));
  } catch {
    // Ignore storage failures (private mode, etc.)
  }
  return id;
};

export const clearStoredReferralId = () => {
  try {
    sessionStorage.removeItem(REFERRAL_STORAGE_KEY);
  } catch {
    // Ignore storage failures
  }
};

export const resolveReferralId = (search = window.location.search) => {
  const fromQuery = parseReferralId(
    new URLSearchParams(search).get("referral_id")
  );
  return fromQuery || getStoredReferralId();
};
